import Liability, { liabilityColumns } from './LiabilityModel'
import { referenceColumns } from './AssetLiabilityModel'
import { LIABILITY_TYPES, IMPORT_COL_TYPES } from '../share/Constants'
import i18next from 'i18next'

class PropertyLoan extends Liability {
  /**
   * Construct a new PropertyLoan instance
   * @param {object} params - PropertyLoan creation options:
   * @param {string} [params.interestRate]
   * @param {string} [params.loanPeriod]
   * @param {string} [params.address]
   * @param {string} [params.lender]
   * @param {string} [params.accountNumber]
   * @param {number} [params.yearOfLoan]
   * @param {number} [params.monthlyPayment]
   * @param {string} [params.typeOfInterestRate]
   */
  constructor({
    _id,
    _rev,
    _deleted,
    title,
    description,
    descriptionWithMarkup,
    percentageOwnership,
    startDate,
    interestRate,
    loanPeriod,
    lender,
    typeOfInterestRate,
    accountNumber,
    yearOfLoan,
    monthlyPayment,
    address,
    maturityDate,
    currency,
    valuationDate,
    valuationDateInBaseCurrency,
    outstandingValueInLiabilityCurrency,
    outstandingValueInBaseCurrency,
    contacts,
    references,
    links,
    documents,
    includeValueInNetWorth,
    status,
    events,
    passwords,
    tags
  }) {
    super({
      _id,
      _rev,
      _deleted,
      title,
      description,
      descriptionWithMarkup,
      percentageOwnership,
      startDate,
      maturityDate,
      currency,
      valuationDate,
      valuationDateInBaseCurrency,
      outstandingValueInLiabilityCurrency,
      outstandingValueInBaseCurrency,
      contacts,
      references,
      links,
      documents,
      includeValueInNetWorth,
      status,
      events,
      passwords,
      tags
    })

    this.subType = LIABILITY_TYPES.PROPERTY_LOAN
    this.interestRate = interestRate
    this.loanPeriod = loanPeriod
    this.address = address
    this.lender = lender
    this.accountNumber = accountNumber
    this.yearOfLoan = yearOfLoan
    this.monthlyPayment = monthlyPayment
    this.typeOfInterestRate = typeOfInterestRate
  }
}

export default PropertyLoan

export const propertyLoanColumns = () => [
  ...liabilityColumns(),
  {
    key: 'startDate',
    title: i18next.t('LIABILITY_START_DATE'),
    type: IMPORT_COL_TYPES.DATE,
    required: true
  },
  {
    key: 'maturityDate',
    title: i18next.t('LIABILITY_MATURITY_DATE'),
    type: IMPORT_COL_TYPES.DATE
  },
  {
    key: 'interestRateValue',
    title: i18next.t('INTEREST_RATE_VALUE'),
    dataIndex: 'interestRate',
    objectKey: 'value',
    type: IMPORT_COL_TYPES.PERCENTAGE
  },
  {
    key: 'interestRateUnit',
    title: i18next.t('INTEREST_RATE_UNIT'),
    dataIndex: 'interestRate',
    objectKey: 'unit',
    type: IMPORT_COL_TYPES.LIST
  },
  {
    key: 'typeOfInterestRate',
    title: i18next.t('TYPE_OF_INTEREST_RATE'),
    type: IMPORT_COL_TYPES.LIST,
    isCustomList: true
  },
  {
    key: 'address',
    title: i18next.t('ADDRESSES'),
    required: true
  },
  {
    key: 'accountNumber',
    title: i18next.t('ACCOUNT_NUMBER')
  },
  {
    key: 'loanPeriodValue',
    title: i18next.t('LOAN_PERIOD_VALUE'),
    dataIndex: 'loanPeriod',
    objectKey: 'value',
    type: IMPORT_COL_TYPES.NUMBER
  },
  {
    key: 'loanPeriodUnit',
    title: i18next.t('LOAN_PERIOD_UNIT'),
    dataIndex: 'loanPeriod',
    objectKey: 'unit',
    type: IMPORT_COL_TYPES.LIST
  },
  {
    key: 'yearOfLoan',
    title: i18next.t('NO_OF_YEARS_REPAYMENT_COMPLETED'),
    type: IMPORT_COL_TYPES.STRING
  },
  {
    key: 'monthlyPayment',
    title: i18next.t('MONTHLY_PAYMENT'),
    type: IMPORT_COL_TYPES.CURRENCY
  },
  ...referenceColumns()
]
